import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["radioToggler", "showHide"]

  static classes = ["hidden"]

  connect() {
    this.radioTogglerTargets.forEach(target => {
      // Only if the target is checked
      if (target.checked) {
        target.dispatchEvent(new Event("change"))
      }
    })
  }

  toggle(event) {
    const value = event.target.value
    this.showHideTargets.forEach(target => {
      target.classList.toggle(this.hiddenClass, value === "0")
    })
  }
}
